import * as React from 'react'
import {FC} from 'react'
import Calculator from '../calculator'
import './index.less'
import GlobalOptionsInterface from '../../types/global-options'

interface AppPropsInterface {
    globalOptions: GlobalOptionsInterface
}

const App: FC<AppPropsInterface> = ({globalOptions}) => {
    return <Calculator globalOptions={globalOptions} />
}

export default App
